// eslint-disable-next-line import/prefer-default-export
export enum Store {
  // default = 'default',
  en = 'kem_en',
  de = 'kem_de',
  fr = 'kem_fr',
  es = 'kem_es',
}
